import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LoadingIndicatorService {
  constructor() { }

  public onLoadingChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  public start() {
    this.onLoadingChanged.emit(true);
  }

  public stop() {
    this.onLoadingChanged.emit(false);
  }


}
